<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .licenses {
    width: 100%;
    .header {
      gap: utils.in_rem(12px);
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }

    .modules {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
  }
</style>

<script>
  import { teamStore } from "../../../api-stores/license-store";
  import AddLicenseButton from "./AddLicenseButton.svelte";
  import LicenseCard from "./LicenseCard/LicenseCard.svelte";
  import { additionsStore } from "./stores";

  export let modules = [];

  $: allowedAlias =
    ($additionsStore.outreach || 0) +
    ($teamStore?.licenses.find((l) => l.kind === "outreach")?.total || 0) -
    ($teamStore?.licenses.find((l) => l.kind === "alias")?.total || 0);
  $: maxAlias = Math.max(allowedAlias, 0);

  const getMax = (licenseKind) => {
    if (licenseKind === "alias") {
      return maxAlias;
    }
    return null;
  };
  const getNotification = (licenseKind) => {
    if (licenseKind === "alias" && $additionsStore[licenseKind] >= maxAlias) {
      return "If you'd like to add more Aliases, please reach out to your Account Manager";
    }
    return "";
  };
</script>

<div class="licenses">
  <div class="header">
    <h3>Licenses</h3>
    <AddLicenseButton {modules} />
  </div>
  <div class="modules">
    {#each Object.keys($additionsStore) as license}
      {@const mod = modules.find((m) => m.kind === license)}
      {@const max = getMax(license)}
      {@const notification = getNotification(license)}
      {#if mod}
        <LicenseCard {mod} {max} {notification} />
      {/if}
    {/each}
  </div>
</div>
